const DEFAULT_API_BY_ENV = {
  development: 'http://localhost:8787',
  production: '/api',
  test: 'http://localhost:8787',
};

const getNodeEnv = () => {
  if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV) {
    return process.env.NODE_ENV;
  }
  return 'development';
};

const trimTrailingSlash = (value) => value.replace(/\/+$/, '');

const readInjectedApiBaseUrl = () => {
  if (typeof window !== 'undefined' && window.__VASTA_CONFIG__ && window.__VASTA_CONFIG__.apiBaseUrl) {
    return String(window.__VASTA_CONFIG__.apiBaseUrl);
  }
  return '';
};

const readBuildTimeApiBaseUrl = () => {
  if (typeof process === 'undefined' || !process.env) {
    return '';
  }

  return (
    process.env.VITE_API_BASE_URL ||
    process.env.REACT_APP_API_BASE_URL ||
    ''
  );
};

export const ENVIRONMENT = getNodeEnv();

const fallbackApi = DEFAULT_API_BY_ENV[ENVIRONMENT] || DEFAULT_API_BY_ENV.development;
const resolvedApiBaseUrl = readInjectedApiBaseUrl() || readBuildTimeApiBaseUrl() || fallbackApi;

export const API_BASE_URL = trimTrailingSlash(resolvedApiBaseUrl);

const exportedConfig = {
  API_BASE_URL,
  ENVIRONMENT,
};

export default exportedConfig;
